import type { ApiVolopId } from '#/api/types/ApiTypedId';
import type { ApiUnpublishedVolop } from '#/modules/listing/volops/api/types/ApiUnpublishedVolop';
import type { ApiVolop } from '#/modules/listing/volops/api/types/ApiVolop';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  data: ApiVolop | ApiUnpublishedVolop;
};

function mapResponse(response: ApiResponse): ApiVolop | ApiUnpublishedVolop {
  return response.data;
}

const embedWidgetEndpoint = new FetchEndpoint({
  urlFactory: (embedSearchWidgetId: string, volopId: ApiVolopId) =>
    `/data/embed-search-widgets/${embedSearchWidgetId}/volops/${volopId}`,
  mapResponse,
});

// Exports

export const listingEmbedApiIsomorphicFetchVolop =
  embedWidgetEndpoint.createIsomorphicFetchFn();
